import React, { FC, useState, useEffect, useRef, ChangeEvent } from 'react';
import clsx from 'clsx';
import { FieldWrapper } from './form-controls';

export interface ResizableTextAreaProps {
  value: string;
  name: string;
  onChange: (value: string) => void;
  maxHeight?: number;
  styles?: string;
  wrapperClasses: string;
  props?: any;
}

export const ResizableTextArea: FC<ResizableTextAreaProps> = ({ value = '', name, onChange, styles, maxHeight=8, wrapperClasses, ...props}) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const parentRef = useRef<HTMLDivElement>(null);

  const [textAreaHeight, setTextAreaHeight] = useState<string>('auto');
  const [clientHeight, setClientHeight] = useState<number>(0);
  const [maxWidth, setMaxWidth] = useState<number>(0);

  const onChangeHandler = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value.toUpperCase();
    onChange(value);
  };

  useEffect(() => {
    setTextAreaHeight(`${textAreaRef.current!.scrollHeight}px`);
    setClientHeight(textAreaRef.current!.clientHeight);
    textAreaRef.current!.scrollIntoView();
  }, [textAreaHeight, clientHeight, textAreaRef, value]);

  useEffect(() => {
    if (parentRef.current) setMaxWidth(parentRef.current.clientWidth);
  }, [parentRef]);

  return (
    <div ref={parentRef} className={wrapperClasses}>
      <FieldWrapper {...props}>
        <textarea
          value={value}
          name={name}
          className={clsx(
            'bg-white p-4 leading-none border-gray-default border resize-none rounded-lg appearance-none font-normal text-black-default focus:outline-none active:outline-none focus:border-2 focus:border-black',
            styles
          )}
          ref={textAreaRef}
          rows={1}
          cols={value?.length ? value?.length + 5 : 6}
          style={{
            maxWidth: `${maxWidth}px`,
            height: textAreaHeight,
            maxHeight: `${maxHeight}rem`,
            overflow: clientHeight > maxHeight * 16 - 10 ? 'auto' : 'hidden',
            width: 'fit-content',
          }}
          onChange={(event) => onChangeHandler(event)}
          {...props}
        />
      </FieldWrapper>
    </div>
  );
};
